import React from 'react'
import "./about.scss";
import contact from "../../img/back.png";
import ContactTeam from '../../components/contactTeam/ContactTeam';

const About = () => {
  return (
    <div className="__fw">
      <div className="__mw">
        <div class="about_banner">
          <img src={require("../../img/back.png")} alt="" />
        </div>
      </div>

      <div className="__mw">
        <div className="about-page">
          <section className="about-hero">
            <div className="container">
              <div className="about-hero__content">
                <span className="about-hero__tag">About Intellitech</span>
                <h1>
                  Science. Innovation. <span>Precision.</span>
                </h1>
              </div>
            </div>
          </section>
          <div className="container">
            {/* Executive Profile Section */}
            <section className="profile">
              <div className="profile__grid">
                <div className="profile__image-area">
                  <div className="profile__image-frame">
                    <img
                      src={require("../../img/2_2.jpg")}
                      alt="Rabih Tannous, PhD"
                    />
                  </div>
                  <div className="profile__title-box">
                    <h5>Rabih Tannous, PhD</h5>
                    <span>Advisor & Scientific Director</span>
                  </div>
                </div>

                <div className="profile__content">
                  <h3 className="profile__subtitle">
                    Where Science Meets Technology
                  </h3>
                  <p className="profile__bio">
                    Rabih Tannous is a PhD-qualified scientist and engineering
                    leader bringing decades of experience in advanced modelling,
                    simulation, and high-reliability systems to the world of
                    algorithmic trading. With a doctorate in Mechanical
                    Engineering from{" "}
                    <strong>George Washington University</strong>, Rabih has
                    built a reputation for transforming complex theoretical
                    concepts into practical, high-performance systems.
                  </p>

                  <div className="profile__experience">
                    <p>Formerly led engineering programs at:</p>
                    <div className="experience-tags">
                      <span>Lockheed Martin</span>
                      <span>BAE Systems</span>
                      <span>Rheinmetall Defence</span>
                    </div>
                  </div>

                  <p className="profile__bio-secondary">
                    An inventor and innovator, Rabih holds multiple U.S. patents
                    and has published over 30 peer-reviewed scientific papers.
                    He applies the same rigor found in aerospace and
                    defense-grade engineering to the architecture of our trading
                    algorithms, ensuring every solution is grounded in validated
                    methodology and scientific precision.
                  </p>
                </div>
              </div>
            </section>

            {/* Brand Pillars Section */}
            <section className="pillars">
              <div className="pillar-item">
                <h4>Science</h4>
                <p>Grounded in data and peer-reviewed methodologies.</p>
              </div>
              <div className="pillar-item">
                <h4>Innovation</h4>
                <p>Patented technology designed for modern markets.</p>
              </div>
              <div className="pillar-item">
                <h4>Precision</h4>
                <p>High-reliability systems engineered for consistency.</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About
